// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__vA7c6","title":"FrontImage_title__uAm3e"};